<template>
  <div
    class="py-6 space-y-6 h-full flex flex-col bg-gray-50 overflow-y-auto custom-scrollbar"
  >
    <!-- === HEADER & STATUS CONTROLS === -->
    <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm mx-1">
      <div
        class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6"
      >
        <div class="flex items-center gap-3">
          <div class="p-3 bg-indigo-50 rounded-xl">
            <i class="pi pi-box text-2xl text-indigo-600"></i>
          </div>
          <div>
            <h1 class="text-2xl font-bold text-gray-900 flex items-center">
              Colis #{{ packageData?.id ? truncateId(packageData.id) : '-' }}
              <div
                v-if="packageData?.reference"
                class="ml-3 px-3 py-1 bg-gray-100 text-gray-700 border border-gray-200 rounded-full text-xs font-mono"
              >
                {{ packageData.reference }}
              </div>
            </h1>
            <p class="text-sm text-gray-500 mt-1">
              Créé le
              {{
                packageData?.orderDate
                  ? Commons.time(packageData.orderDate)
                  : '-'
              }}
            </p>
          </div>
        </div>

        <!-- <div class="flex items-center gap-3">
          <div class="relative group">
            <select
              v-model="selectedStatus"
              class="appearance-none bg-gray-50 border border-gray-200 text-gray-700 text-sm rounded-xl focus:ring-indigo-500 focus:border-indigo-500 block w-full p-2.5 pr-10 min-w-[150px] cursor-pointer"
              :disabled="updatingStatus"
            >
              <option v-for="(opt, key) in statuses" :key="key" :value="key">
                {{ opt.name }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <i class="pi pi-chevron-down text-xs"></i>
            </div>
          </div>
          <button
            @click="handleStatusUpdate"
            :disabled="updatingStatus || selectedStatus === packageData?.status"
            class="px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-300 text-white rounded-xl text-sm font-semibold transition-all shadow-sm flex items-center gap-2"
          >
            <i v-if="updatingStatus" class="pi pi-spin pi-spinner text-xs"></i>
            Mettre à jour
          </button>
        </div> -->
      </div>

      <div class="flex flex-wrap gap-4 pt-4 border-t border-gray-100">
        <div
          class="flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-100"
        >
          <span
            class="text-xs text-gray-500 font-medium uppercase tracking-wider"
            >Paiement:</span
          >
          <span
            class="text-sm font-semibold"
            :class="
              packageData?.payment?.status === 'paid'
                ? 'text-green-600'
                : packageData?.payment?.status === 'failed'
                ? 'text-red-600'
                : 'text-orange-600'
            "
          >
            {{
              packageData?.payment?.status === 'paid'
                ? 'Payé'
                : packageData?.payment?.status === 'failed'
                ? 'Échec'
                : 'En attente'
            }}
          </span>
        </div>
        <div
          class="flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-100"
        >
          <span
            class="text-xs text-gray-500 font-medium uppercase tracking-wider"
            >Méthode:</span
          >
          <span class="text-sm font-semibold text-gray-700">{{
            getPaymentMethod(
              packageData?.payment?.method || packageData?.payment?.provider,
            )
          }}</span>
        </div>
        <button
          v-if="packageData?.reference || packageData?.id"
          @click="
            Copy.toClipboard(
              packageData.reference || packageData.id,
              'ID copié',
            )
          "
          class="flex items-center gap-2 px-3 py-1.5 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-100 transition-colors"
        >
          <i class="pi pi-copy text-xs text-gray-400"></i>
          <span class="text-xs font-medium text-gray-600">ID / Réf</span>
        </button>
      </div>
    </div>

    <!-- === TIMELINE === -->
    <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm mx-1">
      <h3 class="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2">
        <i class="pi pi-clock text-indigo-500"></i>
        Suivi de la livraison
      </h3>

      <div
        class="relative flex items-center justify-between max-w-4xl mx-auto px-4 py-4"
      >
        <div
          class="absolute left-0 right-0 h-0.5 bg-gray-100 -z-10 top-1/2 -translate-y-1/2 mx-10"
        ></div>
        <div
          class="absolute left-0 h-0.5 bg-indigo-500 -z-10 top-1/2 -translate-y-1/2 transition-all duration-1000 mx-10"
          :style="{ width: timelineProgress + '%' }"
        ></div>

        <div
          v-for="(step, index) in timelineSteps"
          :key="step.key"
          class="flex flex-col items-center"
        >
          <div
            class="w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300"
            :class="[
              isStepCompleted(step.key, index)
                ? 'bg-indigo-500 border-indigo-500 text-white shadow-lg shadow-indigo-200'
                : 'bg-white border-gray-200 text-gray-300',
            ]"
          >
            <i :class="step.icon" class="text-sm"></i>
          </div>
          <div class="mt-3 text-center">
            <p
              class="text-xs font-bold leading-tight"
              :class="
                isStepCompleted(step.key, index) ? 'text-gray-900' : 'text-gray-400'
              "
            >
              {{ step.label }}
            </p>
            <p
              v-if="getStepDisplayTime(step.key, index)"
              class="text-[10px] text-gray-500 mt-1 whitespace-nowrap"
            >
              {{ getStepDisplayTime(step.key, index) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- === MAIN CONTENT: SENDER & RECIPIENT === -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mx-1">
      <!-- Sender & Receiver -->
      <div class="space-y-6">
        <div
          class="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden"
        >
          <div
            class="bg-gray-50 px-6 py-3 border-b border-gray-100 flex justify-between items-center"
          >
            <span
              class="text-sm font-bold text-gray-700 uppercase tracking-wider"
              >Itinéraire</span
            >
            <span
              class="text-xs font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded uppercase font-bold"
              >{{ packageData?.deliveryType || 'Moto' }}</span
            >
          </div>
          <div class="p-6 space-y-6">
            <!-- Source (Sender) -->
            <div class="flex gap-4">
              <div class="flex flex-col items-center">
                <div
                  class="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600 flex-shrink-0"
                >
                  <i class="pi pi-map-marker"></i>
                </div>
                <div class="w-0.5 h-full bg-gray-100 my-1"></div>
              </div>
              <div class="flex-1 pb-4">
                <p class="text-[10px] font-bold text-gray-400 uppercase mb-1">
                  Départ (Expéditeur)
                </p>
                <p class="text-sm font-bold text-gray-900">
                  {{ packageData?.customerName }}
                </p>
                <p class="text-sm text-gray-600 mt-1">
                  {{ packageData?.pickupAddress || packageData?.pickupLabel }}
                </p>
                <p
                  class="text-xs text-indigo-600 font-medium mt-1 inline-flex items-center gap-1"
                >
                  <i class="pi pi-phone text-[10px]"></i>
                  {{ packageData?.customerPhoneNumber || '-' }}
                </p>
              </div>
            </div>

            <!-- Checkpoints if any -->
            <div
              v-for="(cp, idx) in packageData?.checkpoints"
              :key="idx"
              class="flex gap-4"
            >
              <div class="flex flex-col items-center flex-shrink-0">
                <div
                  class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 flex-shrink-0"
                >
                  <i class="pi pi-map-marker"></i>
                </div>
                <div class="w-0.5 h-full bg-gray-100 my-1"></div>
              </div>
              <div class="flex-1 pb-4">
                <p class="text-[10px] font-bold text-gray-400 uppercase mb-1">
                  Étape {{ idx + 1 }}
                </p>
                <p class="text-sm font-bold text-gray-900">
                  {{ cp.contactName || 'Contact Étape' }}
                </p>
                <p class="text-sm text-gray-600 mt-1">
                  {{ cp.address }}
                </p>
                <p
                  class="text-xs text-indigo-600 font-medium mt-1 inline-flex items-center gap-1"
                >
                  <i class="pi pi-phone text-[10px]"></i>
                  {{ cp.phone || '-' }}
                </p>
              </div>
            </div>

            <!-- Destination (Recipient) -->
            <div class="flex gap-4">
              <div
                class="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center text-red-600 flex-shrink-0"
              >
                <i class="pi pi-flag-fill"></i>
              </div>
              <div class="flex-1">
                <p class="text-[10px] font-bold text-gray-400 uppercase mb-1">
                  Destination (Destinataire)
                </p>
                <p class="text-sm font-bold text-gray-900">
                  {{ packageData?.recipientName }}
                </p>
                <p class="text-sm text-gray-600 mt-1">
                  {{
                    packageData?.destinationAddress ||
                    packageData?.destinationLabel
                  }}
                </p>
                <p
                  class="text-xs text-indigo-600 font-medium mt-1 inline-flex items-center gap-1"
                >
                  <i class="pi pi-phone text-[10px]"></i>
                  {{ packageData?.recipientPhoneNumber || '-' }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Package Details Card -->
        <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h3
            class="text-sm font-bold text-gray-700 uppercase tracking-wider mb-4"
          >
            Contenu & Spécifications
          </h3>
          <div class="bg-gray-50 rounded-xl p-4 flex items-center gap-4">
            <div
              class="w-12 h-12 bg-white rounded-lg border border-gray-100 flex items-center justify-center shadow-sm"
            >
              <i
                :class="
                  packageData?.packageType === 'document'
                    ? 'pi pi-file'
                    : 'pi pi-box'
                "
                class="text-xl text-gray-400"
              ></i>
            </div>
            <div class="flex-1">
              <p
                class="text-sm font-bold text-gray-900 underline underline-offset-4 decoration-indigo-200 uppercase tracking-wide"
              >
                {{ getPackageTypeLabel(packageData?.packageType) }}
              </p>
              <p class="text-xs text-gray-500 mt-1">
                {{
                  packageData?.title ||
                  packageData?.description ||
                  'Livraison de colis'
                }}
              </p>
            </div>
          </div>
          <div class="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3">
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-[10px] text-gray-400 font-bold uppercase">
                Distance
              </p>
              <p class="text-sm font-bold text-gray-800">
                {{
                  packageData?.route?.distanceFormatted ||
                  packageData?.distanceKm + ' km'
                }}
              </p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-[10px] text-gray-400 font-bold uppercase">Poids</p>
              <p class="text-sm font-bold text-gray-800">
                {{ packageData?.packageInfo?.weight?.value }}
                {{ packageData?.packageInfo?.weight?.unit || 'kg' }}
              </p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-[10px] text-gray-400 font-bold uppercase">
                Quantité
              </p>
              <p class="text-sm font-bold text-gray-800">
                {{ packageData?.packageInfo?.quantity || 1 }}
              </p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-[10px] text-gray-400 font-bold uppercase">
                Fragile
              </p>
              <p
                class="text-sm font-bold"
                :class="
                  packageData?.packageInfo?.fragile
                    ? 'text-red-600'
                    : 'text-gray-800'
                "
              >
                {{ packageData?.packageInfo?.fragile ? 'Oui' : 'Non' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Rider & Payment side -->
      <div class="space-y-6">
        <!-- Rider Info -->
        <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h3
              class="text-sm font-bold text-gray-700 uppercase tracking-wider"
            >
              Livreur & Suivi Temps Réel
            </h3>
            <span
              v-if="hasAssignedRider"
              class="text-[10px] font-bold px-2 py-0.5 rounded-full uppercase"
              :class="packageData?.status === 'delivered' ? 'bg-blue-50 text-blue-600' : 'bg-green-50 text-green-600'"
              >{{ packageData?.status === 'delivered' ? 'Course effectuée' : 'En service' }}</span
            >
          </div>

          <div
            v-if="hasAssignedRider"
            class="space-y-6"
          >
            <div
              class="rounded-xl overflow-hidden border border-gray-100 shadow-inner bg-gray-50 h-[350px]"
            >
              <Map ref="mapRef" @ready="onMapReady" />
            </div>

            <div class="flex items-center gap-4">
              <ImgComponent
                :src="packageData?.rider?.avatar || packageData?.riderAvatar || null"
                class="w-14 h-14 rounded-full border-2 border-white shadow-sm ring-1 ring-gray-100"
                :placeholder="'/images/avatars/rider.png'"
              />
              <div class="flex-1">
                <p class="text-lg font-bold text-gray-900">
                  {{ packageData?.riderName || packageData?.rider?.name || 'Livreur assigné' }}
                </p>
                <p class="text-sm text-gray-500 flex items-center gap-1">
                  <i class="pi pi-phone text-[10px]"></i>
                  {{
                    packageData?.riderPhoneNumber ||
                    packageData?.rider?.phone ||
                    ''
                  }}
                </p>
                <div class="flex items-center gap-2 mt-1">
                  <p
                    class="text-xs font-medium text-indigo-600 flex items-center gap-1 uppercase tracking-tighter"
                  >
                    <i class="pi pi-car text-[10px]"></i>
                    {{
                      packageData?.riderVehicle ||
                      packageData?.rider?.vehicle ||
                      '-'
                    }}
                  </p>
                  <span v-if="packageData?.riderId || packageData?.rider?.id" class="text-[10px] text-gray-400 font-mono">
                    Id Livreur: {{ truncateId(packageData?.riderId || packageData?.rider?.id) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="space-y-6">
            <div
              class="rounded-xl overflow-hidden border border-gray-100 shadow-inner bg-gray-50 h-[350px]"
            >
              <Map ref="mapRef" @ready="onMapReady" />
            </div>
            <p
              class="text-sm text-gray-500 italic text-center py-4 bg-gray-50 rounded-xl border border-dashed border-gray-200"
            >
              Aucun livreur assigné pour le moment. La carte affiche le trajet
              théorique.
            </p>
            <div class="flex justify-center">
              <button
                @click="openRiderSelection"
                class="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-bold rounded-xl transition-all shadow-md flex items-center gap-2"
              >
                <i class="pi pi-user-plus text-xs"></i>
                Assigner manuellement
              </button>
            </div>
          </div>
        </div>

        <!-- Payment Summary -->
        <div
          class="rounded-2xl border border-gray-200 bg-[#1e2749] p-6 shadow-lg text-white relative overflow-hidden"
        >
          <div
            class="absolute -right-4 -top-4 w-24 h-24 bg-indigo-500/20 rounded-full blur-2xl"
          ></div>
          <h3
            class="text-sm font-bold text-indigo-200 uppercase tracking-wider mb-6"
          >
            Récapitulatif Paiement
          </h3>

          <div class="space-y-3">
            <div class="flex justify-between text-indigo-100 text-sm">
              <span>Coût de livraison</span>
              <span class="font-bold font-mono">{{
                Commons.formatNumber(
                  packageData?.pricing?.deliveryFee ||
                    packageData?.pricing?.deliveryCost ||
                    0,
                  {
                    suffix: ' FCFA',
                  },
                )
              }}</span>
            </div>
            <div class="flex justify-between text-indigo-100 text-sm">
              <span>Frais de service</span>
              <span class="font-bold font-mono">{{
                Commons.formatNumber(packageData?.pricing?.serviceFee || 0, {
                  suffix: ' FCFA',
                })
              }}</span>
            </div>
            <div
              v-if="packageData?.pricing?.discount?.amount"
              class="flex justify-between text-green-400 text-sm"
            >
              <span>Remise</span>
              <span class="font-bold font-mono"
                >-{{
                  Commons.formatNumber(
                    packageData?.pricing?.discount?.amount || 0,
                    {
                      suffix: ' FCFA',
                    },
                  )
                }}</span
              >
            </div>

            <div
              class="pt-4 border-t border-white/10 flex justify-between items-end"
            >
              <div>
                <p
                  class="text-[10px] text-indigo-300 uppercase tracking-widest font-bold"
                >
                  Total Facturé
                </p>
                <p class="text-2xl font-black font-mono mt-1 text-white">
                  {{
                    Commons.formatNumber(
                      packageData?.pricing?.total ||
                        packageData?.totalPrice ||
                        0,
                      {
                        suffix: '',
                      },
                    )
                  }}
                  <span class="text-xs font-normal text-indigo-200">FCFA</span>
                </p>
              </div>
              <div
                class="bg-indigo-500/30 px-3 py-1 rounded-lg text-[10px] font-bold uppercase backdrop-blur-sm border border-white/10"
              >
                {{
                  getPaymentMethod(
                    packageData?.payment?.method ||
                      packageData?.payment?.provider,
                  )
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- Timeline Log -->
        <div
          class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm flex flex-col max-h-[300px]"
        >
          <h3
            class="text-sm font-bold text-gray-700 uppercase tracking-wider mb-4"
          >
            Journal d'activité
          </h3>
          <div
            v-if="packageData?.timeline && packageData.timeline.length > 0"
            class="space-y-4 overflow-y-auto custom-scrollbar pr-2 h-full"
          >
            <div
              v-for="(log, idx) in packageData.timeline"
              :key="idx"
              class="flex gap-3"
            >
              <div class="flex flex-col items-center flex-shrink-0">
                <div
                  class="w-2 h-2 rounded-full bg-indigo-400 mt-1.5 opacity-60"
                ></div>
                <div
                  v-if="idx < packageData.timeline.length - 1"
                  class="w-px h-full bg-gray-100 my-1"
                ></div>
              </div>
              <div class="flex-1">
                <p
                  class="text-[11px] font-bold text-gray-800 uppercase leading-none"
                >
                  {{ log.description || getStatusLabel(log.status) }}
                </p>
                <p class="text-[9px] text-gray-400 mt-1">
                  {{ Commons.time(log.timestamp) }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-else
            class="text-center py-4 bg-gray-50 rounded-xl border border-dashed border-gray-100"
          >
            <p class="text-xs text-gray-400">Aucun historique disponible</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Rider Selection Modal -->
    <Teleport to="body">
      <div
        v-if="showRiderModal"
        @click.self="showRiderModal = false"
        class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm cursor-pointer"
      >
        <div
          class="bg-white rounded-3xl w-full max-w-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200 h-[600px] flex flex-col"
        >
          <div
            class="px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-gray-50/50"
          >
            <h2 class="text-xl font-bold text-gray-900">Assigner un livreur</h2>
            <button
              @click="showRiderModal = false"
              class="p-2 hover:bg-gray-200 rounded-full transition-colors text-gray-500"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>

          <div class="p-4 border-b border-gray-100">
            <div class="relative">
              <i
                class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              ></i>
              <input
                v-model="riderSearch"
                type="text"
                placeholder="Rechercher par nom ou téléphone..."
                class="w-full pl-10 pr-4 py-2 bg-gray-100 border-none rounded-xl text-sm focus:ring-2 focus:ring-indigo-500 outline-none"
              />
            </div>
          </div>

          <div class="flex-1 overflow-y-auto p-4 space-y-2 custom-scrollbar">
            <div
              v-if="loadingRiders"
              class="flex flex-col items-center justify-center h-full text-gray-400"
            >
              <i class="pi pi-spin pi-spinner text-2xl mb-2"></i>
              <p class="text-xs">Chargement des livreurs...</p>
            </div>
            <div
              v-else-if="filteredRiders.length === 0"
              class="flex flex-col items-center justify-center h-full text-gray-400"
            >
              <i class="pi pi-user-minus text-2xl mb-2"></i>
              <p class="text-xs">Aucun livreur trouvé</p>
            </div>
            <div
              v-else
              v-for="rider in filteredRiders"
              :key="rider.id"
              @click="confirmRider(rider)"
              class="flex items-center gap-4 p-4 hover:bg-indigo-50 rounded-2xl cursor-pointer transition-all border border-transparent hover:border-indigo-100 group"
            >
              <div class="relative">
                <ImgComponent
                  :src="rider.avatar"
                  class="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm"
                  placeholder="/images/avatars/rider.png"
                />
                <div
                  class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white shadow-sm"
                  :class="
                    rider.status === 'online' ? 'bg-green-500' : 'bg-gray-400'
                  "
                ></div>
              </div>
              <div class="flex-1">
                <p
                  class="text-sm font-bold text-gray-900 group-hover:text-indigo-700 transition-colors"
                >
                  {{ rider.name }}
                </p>
                <div class="flex items-center gap-3">
                  <p class="text-xs text-gray-500 flex items-center gap-1">
                    <i class="pi pi-phone text-[8px]"></i>
                    {{ rider.phone || 'N/A' }}
                  </p>
                  <p
                    v-if="rider.vehicle"
                    class="text-xs text-indigo-500 flex items-center gap-1 uppercase tracking-tighter font-medium"
                  >
                    <i class="pi pi-car text-[8px]"></i>
                    {{ rider.vehicle }}
                  </p>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <i
                  class="pi pi-chevron-right text-gray-300 group-hover:text-indigo-400"
                ></i>
              </div>
            </div>
          </div>

          <div
            class="p-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between"
          >
            <button
              @click="showRiderModal = false"
              class="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 text-xs font-bold rounded-lg transition-all"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import Commons from '@/shared/utils/commons'
import Copy from '@/shared/utils/copy'
import ImgComponent from '@/presentation/components/img/ImgComponent.vue'
import Map from '../map/Map.vue'
import statuses from './statuses.json'
import ApiService from '@/shared/utils/apiService.js'
import Events from '@/events/events'
import { EVENTS } from '@/shared/constants/commons'
import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

const props = defineProps({
  packageData: {
    type: Object,
    default: () => ({}),
  },
})

const updatingStatus = ref(false)
const selectedStatus = ref(props.packageData?.status)
const mapRef = ref(null)

const showRiderModal = ref(false)
const riderSearch = ref('')
const loadingRiders = ref(false)
const availableRiders = ref([])

const filteredRiders = computed(() => {
  if (!riderSearch.value) return availableRiders.value
  const s = riderSearch.value.toLowerCase()
  return availableRiders.value.filter(
    r =>
      r.name.toLowerCase().includes(s) ||
      (r.phone && r.phone.toLowerCase().includes(s)),
  )
})

async function openRiderSelection() {
  showRiderModal.value = true
  loadingRiders.value = true
  try {
    const url = buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RIDERS, {
      queryParams: { status: 'active', limit: 100 },
    })
    const resp = await fetch(url)
    const raw = await resp.json()
    availableRiders.value = (raw?.data?.riders || []).filter(
      r => r.status !== 'offline',
    )
  } catch (e) {
    console.error(e)
  } finally {
    loadingRiders.value = false
  }
}

async function confirmRider(rider) {
  if (!confirm(`Assigner ${rider.name} à ce colis ?`)) return

  try {
    const url = buildApiUrl(ADMIN_ENDPOINTS.ADMIN_ASSIGN_PACKAGE_RIDER, {
      pathParams: { id: props.packageData.id },
    })
    const resp = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ riderId: rider.id }),
    })
    const data = await resp.json()
    if (data.success) {
      showRiderModal.value = false
      Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
        title: 'Succès',
        body: 'Livreur assigné avec succès',
      })
      Events.dispatch('ORDER_UPDATED')
    } else {
      throw new Error(data.error?.message || 'Erreur lors de l’assignation')
    }
  } catch (e) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: e.message,
      type: 'error',
    })
  }
}

const onMapReady = () => {
  traceRoute()
}

function traceRoute() {
  if (!mapRef.value || !props.packageData?.id) return

  const pickupLat =
    parseFloat(props.packageData.pickupLat || props.packageData.pickup?.lat) ||
    6.3571
  const pickupLng =
    parseFloat(props.packageData.pickupLng || props.packageData.pickup?.lng) ||
    2.3699
  const destLat =
    parseFloat(
      props.packageData.destinationLat || props.packageData.destination?.lat,
    ) || 6.3832
  const destLng =
    parseFloat(
      props.packageData.destinationLng || props.packageData.destination?.lng,
    ) || 2.4156

  const checkpoints = (props.packageData.checkpoints || []).map(cp => ({
    lat: parseFloat(cp.lat || cp.latitude),
    lng: parseFloat(cp.lng || cp.longitude),
    content: cp.contactName || cp.name || 'Étape',
  }))

  mapRef.value.traceRouteWithPoints(
    `package-route-${props.packageData.id}`,
    {
      lat: pickupLat,
      lng: pickupLng,
      content: props.packageData.customerName || 'Départ',
      iconType: 'pickup',
    },
    {
      lat: destLat,
      lng: destLng,
      content: props.packageData.recipientName || 'Destination',
      iconType: 'destination',
    },
    checkpoints,
  )

  updateRiderPosition()
}

function updateRiderPosition() {
  if (
    !mapRef.value ||
    (!props.packageData?.riderId && !props.packageData?.riderName)
  )
    return

  const rLat = parseFloat(
    props.packageData.rider?.lat || props.packageData.riderLat,
  )
  const rLng = parseFloat(
    props.packageData.rider?.lng || props.packageData.riderLng,
  )

  if (isNaN(rLat) || isNaN(rLng)) return

  mapRef.value.setMarker(
    {
      position: { lat: rLat, lng: rLng },
      content: props.packageData.riderName || 'Livreur',
      iconType: 'rider',
    },
    `package-route-${props.packageData.id}`,
    'rider-position',
  )
}

watch(
  () => props.packageData,
  newVal => {
    if (newVal) {
      updateRiderPosition()
    }
  },
  { deep: true },
)

const hasAssignedRider = computed(() => {
  return Boolean(
    props.packageData?.riderId ||
    props.packageData?.riderName ||
    props.packageData?.rider?.id ||
    props.packageData?.rider?.name
  )
})

// 1. Alignement des clés dans timelineSteps
const timelineSteps = [
  { key: 'created', label: 'Création', icon: 'pi pi-file' },
  { key: 'payment', label: 'Paiement', icon: 'pi pi-credit-card' },
  { key: 'confirmed', label: 'Accepté', icon: 'pi pi-check-circle' },
  { key: 'picked_up', label: 'Récupéré', icon: 'pi pi-shopping-bag' },
  { key: 'delivered', label: 'Livré', icon: 'pi pi-gift' },
]

const statusOrder = {
  created: 0,
  pending: 0,
  payment_pending: 0,
  payment_paid: 1,
  paid: 1,
  payment: 1,
  assigned: 2,
  confirmed: 2,
  accepted: 2,
  in_transit_to_pickup: 2,
  arrived_at_pickup: 2,
  picked_up: 3,
  in_transit: 3,
  in_transit_to_destination: 3,
  arrived_at_destination: 3,
  delivered: 4,
  completed: 4,
}

// 2. Correction du calcul de la barre de progression
const timelineProgress = computed(() => {
  const steps = timelineSteps.map(s => s.key)
  const currentStatus = props.packageData?.status

  // Mapper les statuts équivalents si nécessaire (ex: assigned -> confirmed)
  const statusMap = {
    created: 'created',
    assigned: 'confirmed',
    confirmed: 'confirmed',
    accepted: 'confirmed',
    picked_up: 'picked_up',
    delivered: 'delivered',
  }

  const mappedStatus = statusMap[currentStatus] || currentStatus
  let currentStatusIdx = steps.indexOf(mappedStatus)

  if (currentStatusIdx === -1) {
    currentStatusIdx = statusOrder[String(currentStatus).toLowerCase()] ?? 0
  }

  return (currentStatusIdx / (steps.length - 1)) * 100
})

// 3. Amélioration de getStepTimestamp
function getStepTimestamp(stepKey) {
  const st = props.packageData?.stepsTimeline || {}

  if (stepKey === 'created') {
    return st.created || st.reference || props.packageData?.createdAt || props.packageData?.orderDate || null
  }
  if (stepKey === 'payment') {
    return (
      st.payment ||
      props.packageData?.payment?.paidAt ||
      (props.packageData?.payment?.status === 'paid'
        ? (st.created || props.packageData?.createdAt)
        : null)
    )
  }
  if (stepKey === 'confirmed') {
    return (
      st.confirmed ||
      st.assigned ||
      props.packageData?.acceptedAt ||
      null
    )
  }
  if (stepKey === 'picked_up') {
    return (
      st.picked_up ||
      st.pickedUp ||
      props.packageData?.pickedUpAt ||
      null
    )
  }
  if (stepKey === 'delivered') {
    return (
      st.delivered ||
      props.packageData?.deliveredAt ||
      null
    )
  }

  return st[stepKey] || null
}

function isStepCompleted(stepKey, stepIndex) {
  if (getStepTimestamp(stepKey)) return true

  const currentStatus = String(props.packageData?.status || '').toLowerCase()
  const currentIdx = statusOrder[currentStatus] ?? -1
  if (currentIdx >= stepIndex) return true

  for (let j = stepIndex + 1; j < timelineSteps.length; j++) {
    if (getStepTimestamp(timelineSteps[j].key)) return true
  }

  return false
}

function getStepDisplayTime(stepKey, stepIndex) {
  const ts = getStepTimestamp(stepKey)
  if (ts) return formatTime(ts)
  if (isStepCompleted(stepKey, stepIndex)) {
    return 'Validé'
  }
  return ''
}

async function handleStatusUpdate() {
  if (
    !selectedStatus.value ||
    selectedStatus.value === props.packageData?.status
  )
    return

  updatingStatus.value = true
  try {
    const pkgId = props.packageData.id
    await ApiService.patch(
      ADMIN_ENDPOINTS.ADMIN_UPDATE_PACKAGE_STATUS.replace(':id', pkgId),
      {
        status: selectedStatus.value,
        reason: "Statut mis à jour par l'administrateur",
      },
    )
    window.location.reload()
  } catch (error) {
    console.error('Échec de la mise à jour:', error)
    alert('Erreur lors de la mise à jour du statut')
  } finally {
    updatingStatus.value = false
  }
}

function getStatusLabel(stat) {
  return statuses[stat]?.name || stat
}

function getPackageTypeLabel(type) {
  const types = {
    document: '📄 Document',
    parcel: '📦 Colis Standard',
    food: '🍕 Alimentaire',
    fragile: '💎 Objet Fragile',
    other: '📑 Divers',
  }
  return types[type] || type || '📦 Colis'
}

function getPaymentMethod(processor) {
  const methods = {
    mobile_money: 'Mobile Money',
    wallet: 'Wallet Rapidoo',
    credit_card: 'Carte Bancaire',
    cash: 'Espèces',
    fedapay: 'FedaPay',
    kkiapay: 'KkiaPay',
  }
  return methods[processor] || processor || 'Espèces'
}

function truncateId(id) {
  if (!id) return '-'
  return id.toString().substring(0, 8).toUpperCase()
}

function formatTime(val) {
  if (!val) return ''
  return Commons.time(val)
}

watch(
  () => props.packageData?.status,
  val => {
    selectedStatus.value = val
  },
  { immediate: true },
)

onMounted(() => {
  selectedStatus.value = props.packageData?.status
})
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}
</style>
